// extracted by mini-css-extract-plugin
export var newsPost = "PostList-module--newsPost--f3Xro";
export var newsPost__header__date = "PostList-module--newsPost__header__date--Fo7LK";
export var newsPost__image = "PostList-module--newsPost__image--HHjAO";